import React from 'react';
import { Input, TrashIcon } from '@avila-tek/ui/src';
import { Criteria, Period } from '../../models';

interface CriteriaInputProps {
  criteria: Criteria;
  formState: Partial<Period>;
  setFormState: React.Dispatch<React.SetStateAction<Period>>;
  index: number;
  expandedIntervals: boolean;
  handleRemoveCriteria: (index: number) => void;
}

function CriteriaInput({
  criteria,
  formState,
  setFormState,
  index,
  expandedIntervals,
  handleRemoveCriteria,
}: CriteriaInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    const { criterias } = formState;
    const newCriterias = [...criterias];
    newCriterias[index] = {
      ...newCriterias[index],
      [name]: Number(value),
    };
    setFormState((prevState) => ({
      ...prevState,
      criterias: newCriterias,
    }));
  };

  // Verificar si es el último ítem y expandedIntervals es false
  const isLastItem =
    !expandedIntervals && index === formState.criterias.length - 1;

  return (
    <div className="w-full flex md:flex-row flex-col gap-5">
      {!isLastItem ? (
        <div className="w-full relative">
          <Input
            name="lowerRange"
            value={criteria?.lowerRange ?? ''}
            label="Límite inferior"
            type="number"
            placeholder="Ingrese el limite inferior % de cumplimiento"
            title="El límite inferior de cada rango debe ser igual al límite superior del rango anterior"
            onChange={handleChange}
            data-idx={index}
          />
        </div>
      ) : null}
      <div className="w-full relative">
        <Input
          name="upperRange"
          value={criteria?.upperRange ?? ''}
          label="Límite superior"
          type="number"
          placeholder="Ingrese el limite superior % de cumplimiento"
          title="El límite superior de cada rango debe ser igual al límite inferior del siguiente rango"
          onChange={handleChange}
          data-idx={index}
          className={isLastItem ? 'bg-slate-100 pl-3' : ''}
          disabled={isLastItem}
        />
        {isLastItem ? (
          <div>
            <label className="absolute top-8 left-3">+</label>
            <label className="absolute top-8 left-[3.75rem]">%</label>
          </div>
        ) : null}
      </div>
      <div className="w-full flex items-end gap-5">
        <Input
          name="reward"
          value={criteria?.reward ?? ''}
          label="Recompensa"
          type="number"
          placeholder="Ingrese el número de puntos con los que se recompensará este rango de cumplimiento"
          title="Número de puntos con los que se recompensará este rango de cumplimiento"
          onChange={handleChange}
          data-idx={index}
          className={isLastItem ? ' w-[375px] lg:!w-[450px]' : 'w-80 lg:w-96'}
        />
        {!isLastItem ? (
          <button
            onClick={() => handleRemoveCriteria(index)}
            type="button"
            className="w-[5%] text-center bg-transparent mb-2"
          >
            <TrashIcon className="w-6 h-6 text-red-500 hover:text-red-400" />
          </button>
        ) : (
          <div className="w-[5%]" />
        )}
      </div>
    </div>
  );
}

export default CriteriaInput;
